enum MarkerColorEnum {
  // primary-c
  HOTEL = '%230054a6',
  // accent-darker-c
  ATRAKCJA = '%23ffbf00',
  WYCIECZKA = '%23d72567',
  // primary-c
  BIURO = '%230054a6',
  // primary-c
  CZARTER = '%230054a6',
  ACTIVE_BACKGROUND = '%23ffbf00',
  INACTIVE_BACKGROUND = 'white',
  ACTIVE_TEXT = '%230054a6',
  INACTIVE_TEXT = 'black',
}
export default MarkerColorEnum;
